import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { SWRConfig } from 'swr'
import zhCN from 'antd/es/locale/zh_CN'

import './index.css'
import App from './App'
import store from './redux/store'
import fetchJson from './public/fetcher'
import { ConfigProvider } from 'antd'

declare global {
  interface Window {
    JSEncrypt: any
  }
  interface Window {
    TencentCaptcha: any
  }
}

ReactDOM.render(
  <Provider store={store}>
    <SWRConfig value={{ fetcher: fetchJson, shouldRetryOnError: false }}>
      <ConfigProvider locale={zhCN}>
        <App />
      </ConfigProvider>
    </SWRConfig>
  </Provider>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//serviceWorker.unregister();
